import {
  GETCUSTOMERBANKDETAILS_SUCCESS,
  GETCUSTOMERBANKDETAILS_FAILED,
  RESET_GETCUSTOMERBANKDETAILS,
  LOADING_GETCUSTOMERBANKDETAILS,
  NETWORK_ERROR_GETCUSTOMERBANKDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetCustomerbankdetails = () => {
  return { type: RESET_GETCUSTOMERBANKDETAILS };
};

const getCustomerbankDetailsReq = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETCUSTOMERBANKDETAILS });
  await partnerServices
    .post(
      "getCustomerBankDetails", userData, { headers: { AuthToken: authTokenIs } }
    )
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getCustomerBankDetailssuccess(res.data));
          break;
        default:
          dispatch(getCustomerBankDetailsFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETCUSTOMERBANKDETAILS,
        payload: err,
      });
    });
};
function getCustomerBankDetailssuccess(data) {
  return {
    type: GETCUSTOMERBANKDETAILS_SUCCESS,
    payload: data,
  };
}
function getCustomerBankDetailsFailed(data) {
  return {
    type: GETCUSTOMERBANKDETAILS_FAILED,
    payload: data,
  };
}

export { resetGetCustomerbankdetails, getCustomerbankDetailsReq };
